import { PersonAuthorisationType } from '../../../providers/ActivationObjectProvider/types'
import { AuthorityDropdownItem } from '../../../../types'
import { WizzardStep1Form } from '../types'

export const DefaultValue: WizzardStep1Form = {
    personName: '',
    personType: 'Physical',
    personAuthorisationType: 'Owener',
    personPhoneNumber: '',
    personEmail: '',
    useSettingsAnotherContract: false,
    check1: false,
    check2: false,
    numberAnotherContract: '',
    unifyInvoicing: false,
    objectType: undefined,
}

export const PersonAuthorisationTypes: Record<PersonAuthorisationType, string> = {
    Owener: 'Majitel objektu',
    Renter: 'Nájemce objektu',
    StatutoryAuthority: 'Statutární organ',
    AuthRepresentative: 'Oprávněný zástupce',
    Other: 'Jiný',
}

export const PersonAuthorisationTypesList: AuthorityDropdownItem<PersonAuthorisationType>[] = [
    { value: 'Owener', label: PersonAuthorisationTypes.Owener, isPhysical: true },
    { value: 'Renter', label: PersonAuthorisationTypes.Renter, isPhysical: true },
    { value: 'StatutoryAuthority', label: PersonAuthorisationTypes.StatutoryAuthority, isPhysical: false },
    { value: 'AuthRepresentative', label: PersonAuthorisationTypes.AuthRepresentative, isPhysical: false },
    { value: 'Other', label: PersonAuthorisationTypes.Other, isPhysical: true },
    { value: 'Other', label: PersonAuthorisationTypes.Other, isPhysical: false },
]
